import fetchPortalJson from '../../js/PortalFetchJson'
import postPortalJson from '../../js/PortalPostJson'
import putPortalJson from '../../js/PortalPutJson'
import getAdditionalQuestions from '../../js/GetAdditionalQuestions'
import {
  TO_LEAD_EDUCATION_MODEL,
  TO_LEAD_BACKGROUND_MODEL,
  TO_ALL_MODELS
} from '../../js/ModelHelpers.js'

const state = () => ({
  info: {},
  leadId: null,
  addressId: null,
  educationId: null,
  backgroundId: null,
  consentId: null,
  callcenterId: null,
  displayFields: [],
  fieldValueDisplayMap: {},
  questions: [],
  pages: [],
  prefillEvaluated: false,
  errors: {}
})

const getters = {
  getInfo: (state) => {
    if (state.info.area_study_ids !== undefined) {
      state.info['lead_education[subject_ids]'] = state.info.area_study_ids
    }

    return {
      ...state.info
    }
  },
  getValueDisplay: (state) => (field, value) => {
    return state.fieldValueDisplayMap[field] ? state.fieldValueDisplayMap[field][value] : null
  },
  getErrors: (state) => {
    return state.errors ? { ...state.errors } : {}
  },
  getFields: (state) => {
    return Object.keys(state.info)
  }
}

const actions = {
  async save ({
    commit,
    state
  }, leadId) {
    var allDataModels = TO_ALL_MODELS(state.info)
    var errors = {}
    var leadResults = {}
    var leadModel = allDataModels.lead
    try {
      if (state.questions.some((q) => q.model === 'lead')) {
        leadResults = await putPortalJson(`leads/${leadId}`, {
          lead: leadModel
        })
      }
    } catch {
      Object.keys(leadResults.errors).forEach((key) => { errors[`lead[${key}]`] = leadResults.errors[key][0] })
    }
    if (leadResults.errors) {
      Object.keys(leadResults.errors).forEach((key) => { errors[`lead[${key}]`] = leadResults.errors[key][0] })
    }

    var addressResults = {}
    var addressModel = allDataModels.lead_address
    try {
      if (state.questions.some((q) => q.model === 'lead_address')) {
        addressResults = await putPortalJson(`lead_addresses/${state.addressId}`, {
          lead_address: addressModel
        })
      }
    } catch {
      Object.keys(addressResults.errors).forEach((key) => { errors[`lead_address[${key}]`] = addressResults.errors[key][0] })
    }
    if (addressResults.errors) {
      Object.keys(addressResults.errors).forEach((key) => { errors[`lead_address[${key}]`] = addressResults.errors[key][0] })
    }

    var ccResults = {}
    var ccModel = allDataModels.lead_call_center
    try {
      if (state.questions.some((q) => q.model === 'lead_call_center')) {
        ccResults = await putPortalJson(`lead_call_centers/${state.callcenterId}`, {
          lead_call_center: ccModel
        })
      }
    } catch {
      Object.keys(ccResults.errors).forEach((key) => { errors[`lead_call_center[${key}]`] = ccResults.errors[key][0] })
    }
    if (ccResults.errors) {
      Object.keys(ccResults.errors).forEach((key) => { errors[`lead_call_center[${key}]`] = ccResults.errors[key][0] })
    }

    var educationResults = {}
    var educationModel = allDataModels.lead_education
    educationModel.lead_id = leadId
    try {
      if (state.questions.some((q) => q.model === 'lead_education')) {
        if (state.educationId !== null) {
          educationResults = await putPortalJson(`lead_educations/${state.educationId}`, {
            lead_education: educationModel
          })
        } else {
          educationResults = await postPortalJson('lead_educations', {
            lead_education: educationModel
          })
          commit('setEducationId', educationResults.lead_education.id)
        }
      }
    } catch {
      Object.keys(educationResults.errors).forEach((key) => { errors[`lead_education[${key}]`] = educationResults.errors[key][0] })
    }
    if (educationResults.errors) {
      Object.keys(educationResults.errors).forEach((key) => { errors[`lead_education[${key}]`] = educationResults.errors[key][0] })
    }
    var backgroundResults = {}
    var backgroundModel = allDataModels.lead_background
    backgroundModel.lead_id = leadId
    try {
      if (state.questions.some((q) => q.model === 'lead_background')) {
        if (state.backgroundId !== null) {
          backgroundResults = await putPortalJson(`lead_backgrounds/${state.backgroundId}`, {
            lead_background: backgroundModel
          })
        } else {
          backgroundResults = await postPortalJson('lead_backgrounds', {
            lead_background: backgroundModel
          })
          commit('setBackgroundId', backgroundResults.lead_background.id)
        }
      }
    } catch {
      Object.keys(backgroundResults.errors).forEach((key) => { errors[`lead_background[${key}]`] = backgroundResults.errors[key][0] })
    }
    if (backgroundResults.errors) {
      Object.keys(backgroundResults.errors).forEach((key) => { errors[`lead_background[${key}]`] = backgroundResults.errors[key][0] })
    }
    var consentResults = {}
    var consentModel = allDataModels.lead_consent
    consentModel.lead_id = leadId
    try {
      if (state.questions.some((q) => q.model === 'lead_consent')) {
        if (state.consentId !== null) {
          consentResults = await putPortalJson(`lead_consents/${state.consentId}`, {
            lead_consent: consentModel
          })
        } else {
          consentResults = await postPortalJson('lead_consents', {
            lead_consent: consentModel
          })
          commit('setConsentId', consentResults.lead_consent.id)
        }
      }
    } catch {
      Object.keys(consentResults.errors).forEach((key) => { errors[`lead_consent[${key}]`] = consentResults.errors[key][0] })
    }
    if (consentResults.errors) {
      Object.keys(consentResults.errors).forEach((key) => { errors[`lead_consent[${key}]`] = consentResults.errors[key][0] })
    }

    var customValueResults = {}
    var customValueModel = allDataModels.lead_custom_value
    customValueModel.lead_id = leadId
    try {
      if (state.questions.some((q) => q.model === 'lead_custom_value')) {
        customValueResults = await postPortalJson('lead_custom_values', {
          lead_custom_values: customValueModel
        })
      }
    } catch {
      Object.keys(customValueResults.errors).forEach((key) => { errors[`lead_custom_value[${key}]`] = customValueResults.errors[key][0] })
    }
    if (customValueResults.errors) {
      Object.keys(customValueResults.errors).forEach((key) => { errors[`lead_custom_value[${key}]`] = customValueResults.errors[key][0] })
    }
    commit('setErrors', errors)
  },
  async convertToIdsAndSetFields ({ commit, state }, fieldsAndValues) {
    var convertedFields = {}
    for (const field in fieldsAndValues) {
      const originalValue = fieldsAndValues[field]
      var newKey = field.includes('[') ? { field } : state.questions.find((q) => q.fieldName === field) ?? { field }
      var newValue = newKey.values?.find((v) => v.mappingValue === originalValue || originalValue === '' + v.value)?.value
      if (newValue !== undefined && newValue !== null) {
        convertedFields[newKey.field] = newValue
      } else if (/^\d+$/.test(originalValue)) {
        convertedFields[newKey.field] = originalValue
      } else {
        if (newKey.field === 'area_study_ids') {
          var newValues = []
          var valueSplit = originalValue.split(',')

          for (var i = 0; i < valueSplit.length; i++) {
            const mappingResult = await (fetchPortalJson(`list_mapping_items/area-of-study-${valueSplit[i].trim()}`).catch((e) => { return {} }))
            if (mappingResult.list_mapping_item) {
              newValues.push(mappingResult.list_mapping_item.value)
            } else {
              newValues.push('area-of-study-' + valueSplit[i].trim())
            }
          }

          convertedFields[newKey.field] = newValues
        } else {
          const mappingResult = await (fetchPortalJson(`list_mapping_items/${originalValue}`).catch((e) => { return {} }))
          if (mappingResult.list_mapping_item) {
            convertedFields[newKey.field] = mappingResult.list_mapping_item.value
          } else {
            convertedFields[newKey.field] = originalValue
          }
        }
      }
    }
    commit('setObjectFields', convertedFields)
  },
  loadEducation ({ commit }, education) {
    commit('setEducationId', education.id)
    var eduModel = TO_LEAD_EDUCATION_MODEL(education)
    var apiSchoolType = eduModel.education['lead_education[school_type_ids]']
    eduModel.education['lead_education[school_type_ids]'] = apiSchoolType.length > 1 ? '3' : apiSchoolType[0]
    // eduModel.education['lead_education[education_level_id]'] = `${eduModel.education['lead_education[education_level_id]']}`
    if (eduModel.education['lead_education[grad_year]']) {
      eduModel.education['lead_education[grad_year]'] = `${eduModel.education['lead_education[grad_year]']}`
    }
    if (eduModel.education['lead_education[level_interest]']) {
      eduModel.education['lead_education[level_interest]'] = parseInt(eduModel.education['lead_education[level_interest]'])
    }
    commit('setObjectFields', eduModel.education)
  },
  loadBackground ({ commit, state }, background) {
    commit('setBackgroundId', background.id)
    var backgroundModel = TO_LEAD_BACKGROUND_MODEL(background)
    const militaryValue = backgroundModel.background['lead_background[military_type]']
    const militaryQuestion = state.questions.find((q) => q.field === 'lead_background[military_type]')
    if (militaryValue && militaryQuestion) {
      backgroundModel.background.military_status = militaryQuestion.values.find((v) => v.rawValue === 'No Military Affiliation')?.value === parseInt(militaryValue) ? 'no' : 'yes'
    }
    commit('setObjectFields', backgroundModel.background)
  },
  async getQuestions ({ commit, dispatch }, consumerAndPrepop) {
    var consumerId = consumerAndPrepop.consumerId
    var callDirection = consumerAndPrepop.callDirection
    var consumerQuestions = await getAdditionalQuestions(consumerId, callDirection)
    var questionList = []
    var setupQuestion = (q) => {
      var fullQuestion = { ...q }
      q.values.forEach((valueObject) => {
        var fieldDisplayMap = { field: q.field, label: valueObject.label, value: `${valueObject.value}` }
        commit('addFieldDisplayMap', fieldDisplayMap)
      })
      if (q.defaultLabel) {
        fullQuestion.default = fullQuestion.values.find((val) => val.label === q.defaultLabel).value
      }
      questionList.push(fullQuestion)
    }
    for (var qIndex = 0; qIndex < consumerQuestions.questionArray.length; qIndex++) {
      setupQuestion(consumerQuestions.questionArray[qIndex])
    }
    commit('setPages', consumerQuestions.pages)
    commit('setDisplayFields', questionList.filter((q) => q.displayName && q.type !== 'HiddenField' && q.type !== 'OnlyLabel').map((q) => ({ field: q.field, label: q.displayName })))
    commit('setQuestions', questionList)
    await dispatch('convertToIdsAndSetFields', consumerAndPrepop.prepop)
    commit('setPrefillEvaluated')
  },
  importNeededInfo ({ commit, state }, importInfo) {
    var fieldsAndValues = importInfo.fieldsAndValues
    var convertedFields = {}
    for (const field in fieldsAndValues) {
      var newKey = `${importInfo.model}[${field}]`
      if (importInfo.model !== 'lead_custom_value' || state.questions.some((q) => q.field === newKey)) {
        convertedFields[newKey] = fieldsAndValues[field]
      }
    }
    const importId = importInfo.fieldsAndValues.id
    switch (importInfo.model) {
      case 'lead_address':
        commit('setAddressId', importId ?? state.addressId)
        break
      case 'lead_call_center':
        commit('setCallCenterId', importId ?? state.callcenterId)
        break
      case 'lead_background':
        commit('setBackgroundId', importId ?? state.backgroundId)
        break
      case 'lead_education':
        commit('setEducationId', importId ?? state.educationId)
        break
      case 'lead_consent':
        commit('setConsentId', importId ?? state.consentId)
        break
    }
    commit('setObjectFields', convertedFields)
  }
}

const mutations = {
  setField (state, fieldUpdate) {
    var updatedInfo = state.info
    updatedInfo[fieldUpdate.field] = fieldUpdate.value
    state.info = updatedInfo
    delete state.errors[fieldUpdate.field]
  },
  setObjectFields (state, fieldsAndValues) {
    state.info = {
      ...state.info,
      ...fieldsAndValues
    }
  },
  addObjectFields (state, fieldsAndValues) {
    state.info = {
      ...fieldsAndValues,
      ...state.info
    }
  },
  setAddressId (state, addressId) {
    state.addressId = addressId
  },
  setCallCenterId (state, callcenterId) {
    state.callcenterId = callcenterId
  },
  setEducationId (state, educationId) {
    state.educationId = educationId
  },
  setBackgroundId (state, backgroundId) {
    state.backgroundId = backgroundId
  },
  setConsentId (state, consentId) {
    state.consentId = consentId
  },
  setErrors (state, errors) {
    state.errors = errors
  },
  setDisplayFields (state, fields) {
    state.displayFields = fields
  },
  addFieldDisplayMap (state, fieldMap) {
    var updatedMap = state.fieldValueDisplayMap[fieldMap.field] ? { ...state.fieldValueDisplayMap[fieldMap.field] } : {}
    updatedMap[fieldMap.value] = fieldMap.label
    state.fieldValueDisplayMap[fieldMap.field] = updatedMap
  },
  setQuestions (state, questionList) {
    state.questions = questionList
  },
  setPages (state, pages) {
    state.pages = pages
  },
  setPrefillEvaluated (state) {
    state.prefillEvaluated = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
